export const ActiveTokensInitialState: ActiveTokensInitialState = {
    invalidate: {
        error: undefined,
        success: undefined,
    },
};

export interface ActiveTokensInitialState {
    invalidate: {
        error: string;
        success: string;
    };
}
